module.exports = __webpack_public_path__ + "image/p6-pic1.1782790484418.png";